import React from "react";
import { useRef } from "react";
import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import "./styles.css";

export default function Point({ point, currentSection, visited, setSection }) {
  const { t } = useTranslation();
  const ref = useRef();
  const { name } = point;
  const isVisited = visited.includes(name);

  const goToPoint = (e) => {
    setSection(name, e.currentTarget);
  };

  useEffect(() => {
    //Hide point
    if (currentSection.name === name) ref.current.style.transform = "scale(0)";
    else ref.current.style.transform = "scale(1)";

    if (isVisited) ref.current.style.animation = "none";
  }, [currentSection]);

  return (
    <div>
      <div className="point" id={name}>
        <div className="point-label" onClick={goToPoint} ref={ref}></div>
        <div className="point-tooltip">{t(`${name}.title`)}</div>
        {!isVisited && <div className="point-pulse"></div>}
      </div>
    </div>
  );
}
